import { IPreparationProfile, IPreparationProfileValidation } from '../types/preparationProfiles';
import { localeStore } from '~/mobx/localesStore';
import { capitalLetter } from '~/utils/formatter';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { defaultValidation } from '~/constants/main';

export enum PreparationTimeUnit {
  MINS = 'm',
  HOURS = 'h',
  DAYS = 'd',
}

export enum PreOrderPeriodUnit {
  ONLY_TODAY = 'today',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
}

export enum PreOrderInterval {
  ONE = 1,
  FIVE = 5,
  FIFTEEN = 15,
  THIRTY = 30,
  SIXTY = 60,
}

export const defaultPreparationProfile: IPreparationProfile = {
  id: 0,
  externalId: '',
  name: '',
  deliveryUnit: PreparationTimeUnit.MINS,
  deliveryTime: '',
  deliveryPreparationTime: '',
  pickupUnit: PreparationTimeUnit.MINS,
  pickupTime: '',
  pickupPreparationTime: '',
  preOrderPeriod: '',
  preOrderPeriodUnit: PreOrderPeriodUnit.ONLY_TODAY,
  preOrderInterval: 1,
  branches: [],
  is_default: 0,
};

export const defaultPreparationProfileValidation: IPreparationProfileValidation = {
  isValid: true,
  deliveryTime: defaultValidation,
  deliveryPreparationTime: defaultValidation,
  pickupTime: defaultValidation,
  pickupPreparationTime: defaultValidation,
  preOrderPeriod: defaultValidation,
};

export const preparationTimeUnitOptions = (): IPickerOption[] => {
  return [
    { value: PreparationTimeUnit.MINS, label: capitalLetter(localeStore.t('txt_minutes')) },
    { value: PreparationTimeUnit.HOURS, label: capitalLetter(localeStore.t('txt_hours')) },
    { value: PreparationTimeUnit.DAYS, label: capitalLetter(localeStore.t('days')) },
  ];
};

export const preparationPreOrderPeriodUnitOptions = (): IPickerOption[] => {
  return [
    { value: PreOrderPeriodUnit.ONLY_TODAY, label: localeStore.t('only_today') },
    { value: PreOrderPeriodUnit.DAYS, label: capitalLetter(localeStore.t('days')) },
    { value: PreOrderPeriodUnit.WEEKS, label: localeStore.t('weeks') },
    { value: PreOrderPeriodUnit.MONTHS, label: localeStore.t('months') },
  ];
};

export const preparationPreOrderIntervalOptions = (): IPickerOption[] => {
  return [
    { value: PreOrderInterval.ONE, label: '1 ' + localeStore.t('txt_min').toLowerCase() },
    { value: PreOrderInterval.FIVE, label: '5 ' + localeStore.t('txt_mins').toLowerCase() },
    { value: PreOrderInterval.FIFTEEN, label: '15 ' + localeStore.t('txt_mins').toLowerCase() },
    { value: PreOrderInterval.THIRTY, label: '30 ' + localeStore.t('txt_mins').toLowerCase() },
    { value: PreOrderInterval.SIXTY, label: '1 ' + localeStore.t('txt_hour').toLowerCase() },
  ];
};

export const preOrderPeriodMaxLength: Record<PreOrderPeriodUnit, number> = {
  [PreOrderPeriodUnit.ONLY_TODAY]: 0,
  [PreOrderPeriodUnit.DAYS]: 365,
  [PreOrderPeriodUnit.WEEKS]: 52,
  [PreOrderPeriodUnit.MONTHS]: 12,
};
